
<template>
  <section class="wrapper add-new-charity">
    <div style="display:none;">
      <charity-upload-agreement :charityId="charityId"
                        :uploadOnSubmit="true"
                        @refresh="onSuccess"
                        ref="uploadAgreement">
      </charity-upload-agreement>
    </div>
    <h1>Add New Charity</h1>
    <h2 class="tab-heading">Charity Information</h2>
    <charity-information :data="data" ref="charityInformation" @addFile="onAddFile"></charity-information>
    <p v-if="hasErrors" class="error-message">
      There were errors processing the form. Please fix the fields above.
    </p>
    <div class="field buttons left">
      <input type="submit" class="btn" value="Save New Charity" @click="submit" :disabled="isLoading">
      <a class="secondary-action" @click="clearData">Cancel</a>
    </div>
  </section>
</template>

<script>

import store from '@/store'
import CharityInformation from '@/components/Charity/CharityInformation'
import CharityUploadAgreement from '@/components/Charity/CharityUploadAgreement'
export default {
  name: 'CharityAdd',
  beforeRouteEnter (to, from, next) {
    Promise.all([
      store.dispatch('syncConstants'),
      store.dispatch('syncSummary'),
    ]).catch(() => {
      next(vm => vm.$router.push({name: 'CharitiesSummary'}))
    }).then(() => {
      next()
    })
  },
  data () {
    return {
      data: {
        contacts: {
          main: {},
          marketing: {},
          accounting: {},
          charity_agreement_signator: {},
        }
      },
      hasFile: false,
      hasErrors: false,

      isLoading: false,

      showUploadAgreement: false,
      charityId: null,
    }
  },
  methods: {
    onAddFile (file) {
      this.data = Object.assign({}, this.data, {
        file: file.file
      })
      this.$refs.uploadAgreement.$refs.upload.add(file.file)
      this.hasFile = true
    },
    uploadAgreement () {
      this.$refs.uploadAgreement.upload()
    },
    setData () {
    },
    submit () {
      this.isLoading = true
      let form = new FormData()
      for (var field in this.data) {
        if (field === 'proceeds_rate_id' && typeof this.data.proceeds_rate_id === 'object') {
          form.append(field, this.data[field]['value'])
        } else if (field === 'contacts') {
          var types = Object.keys(this.data[field])
          for (var i = types.length - 1; i >= 0; i--) {
            for (var key in this.data[field][types[i]]) {
              form.append('contacts[' + types[i] + '][' + key + ']', this.data[field][types[i]][key])
            }
          }
        } else if (this.data.hasOwnProperty(field) && field !== 'file') {
          if (this.data[field] === true) {
            form.append(field, 1)
          } else if (this.data[field] === false) {
            form.append(field, 0)
          } else {
            form.append(field, this.data[field])
          }
        }
      }
      form.append('add', true)
      store.functions.charity.createCharity(
        form,
        (errors) => {
          this.$refs.charityInformation.errors = errors
          this.$refs.charityInformation.hasErrors = true
          this.hasErrors = true
          this.isLoading = false
        }).then((response) => {
        this.charityId = response.data.id
        if (this.data.file) {
          this.$refs.uploadAgreement.updatePost(this.charityId)
          this.$nextTick(() => {
            this.uploadAgreement()
          })
        } else {
          this.onSuccess()
        }
      })
    },
    onSuccess () {
      this.isLoading = false
      store.storage.charities_dirty = true
      this.$router.push({name: 'CharitiesSummary'})
    },
    clearData () {
      this.data = {}
      this.$refs.charityInformation.errors = {}
      this.$refs.charityInformation.hasErrors = false
      this.hasErrors = false
    },

    modalClick (e) {
      // Only exit if we click outside the content area
      if (e.target === this.$refs.mask && !this.modified) {
        this.showing = false
      }
    },
  },
  computed: {
  },
  components: {
    CharityInformation,
    CharityUploadAgreement
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Charity/CharityAdd.vue